import * as React from "react";

const MobileAppIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      d="M12.5 2h-1a.5.5 0 1 0 0 1h1a.5.5 0 1 0 0-1m-2 20h3a.5.5 0 1 0 0-1h-3a.5.5 0 1 0 0 1M17.5 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
    ></path>
    <path
      fill="#000"
      d="M18 0H6C4.897 0 4 .897 4 2v20c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2m1 22c0 .551-.448 1-1 1H6c-.552 0-1-.449-1-1v-2h14zm0-3H5V2c0-.551.448-1 1-1h12c.552 0 1 .449 1 1z"
    ></path>
    <path
      fill="#000"
      d="M10.5 6h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5M10 9H8V7h2zm6.5-3h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5M16 9h-2V7h2zm-5.5 3h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5m-.5 3H8v-2h2zm6.5-3h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5m-.5 3h-2v-2h2z"
    ></path>
  </svg>
);

export default MobileAppIcon;
